/* eslint-disable camelcase */
import _ from "lodash";


export default {
  set_all(state, data) {
    state = _.assign(state, data);
  },
  //   set_mode(state, data) {
  //     state.docker.mode = data;
  //   },

  set_env(state, data) {
    state.env = data;
  },

 
  set_codeBase(state, data) {
    if (data && data.enterpriseNo) {
      state.eNo = data.enterpriseNo;
    }
    if (data && data.digitCode) {
      state.code = data.digitCode;
    }
    state.codeBase = data;
  },

  set_childData(state, data) {
    state.childData = data;
  },

  set_decodestatus(state, data) {
    state.decodestatus = data;
  },

  set_lang(state, data) {
    state.lang = data;
  },
  set_enterprise(state, data) {
    state.enterprise = data;
  },


  
  set_gis(state, data) {
    sessionStorage.setItem("gis", JSON.stringify(data));

    if (state.env.platform == "mp") {
      data.timestamp = data.timestamp || new Date().getTime();
      wx.setStorageSync("gis", data);
    }

    state.gis = data;
  },
  set_gpsType(state, data) {
    state.gpsType = data;
  },
  set_code(state, data) {
    state.code = data;
  },
  set_eNo(state, data) {
    state.eNo = data;
  },
  set_channelType(state, data) {
    state.channelType = data;
  },
  set_loadedLangPackages(state, data) {
    state.loadedLangPackages = _.assign(state.loadedLangPackages, data);
  },
};
